// SubTabs — inline pill-segmented tab control.
// Designed to live inside Section's `right` slot (or anywhere a small
// inline tab switcher is needed). Visual matches the design's segmented control.
import React from 'react'
import { theme as defaultTheme, T } from './tokens'

/**
 * Props:
 *   tabs    : Array<string> | Array<{ label, value, disabled? }>
 *   value   : current tab value (matches `value` of an entry, or index for string array)
 *   onChange: (value) => void
 */
export default function SubTabs({ tabs = [], value, onChange, theme = defaultTheme }) {
  const items = tabs.map((t, i) => (
    typeof t === 'string'
      ? { label: t, value: i }
      : { ...t, value: t.value ?? i }
  ))
  return (
    <div style={{
      display: 'inline-flex', gap: 2, padding: 3,
      background: theme.bgSub, borderRadius: 7,
      border: `1px solid ${theme.border}`,
      fontFamily: T.fontUI,
    }}>
      {items.map(item => {
        const on = item.value === value
        return (
          <button key={item.value}
            onClick={() => !item.disabled && onChange(item.value)}
            disabled={item.disabled}
            style={{
              padding: '4px 12px', borderRadius: 5,
              border: 'none',
              background: on ? theme.surface : 'transparent',
              color: on ? theme.text : theme.textSub,
              fontSize: 12, fontWeight: on ? 600 : 500,
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              opacity: item.disabled ? 0.5 : 1,
              boxShadow: on ? `0 1px 2px ${theme.border}` : 'none',
              fontFamily: T.fontUI,
              whiteSpace: 'nowrap',
            }}>{item.label}</button>
        )
      })}
    </div>
  )
}
